// Messages for operator/Login (auto-merged by lib/i18n.ts).
export const en = {
  'operator.login.head': 'Sign in — Operator',
  'operator.login.title': 'Sign in',
  'operator.login.subtitle_lead': 'Geo4Logistics operator console',
  'operator.login.email': 'Email',
  'operator.login.password': 'Password',
  'operator.login.remember': 'Keep me signed in on this device',
  'operator.login.submit': 'Sign in',
}

export const zhTW = {
  'operator.login.head': '登入 — 操作端',
  'operator.login.title': '登入',
  'operator.login.subtitle_lead': 'Geo4Logistics 操作端主控台',
  'operator.login.email': '電子郵件',
  'operator.login.password': '密碼',
  'operator.login.remember': '在此裝置上保持登入',
  'operator.login.submit': '登入',
}
